<template>
  <v-list-item-group
      :value="value"
      mandatory
      @input="onInput"
  >
    <slot/>
  </v-list-item-group>
</template>

<script>
export default {
  name: "ListItemGroup",
  props: {
    value: {
      type: Number
    }
  },
  methods: {
    onInput(value) {
      this.$emit("input", value);
    }
  }
}
</script>

<style scoped>

</style>